import users from './users';
import partners from './partners';
import participant from './participant';
import partnerCategories from './partnerCategories';

export default {
    users,
    partners,
    participant,
    partnerCategories
};



// WEBPACK FOOTER //
// ./src/js/reducers/admin/index.js